import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router'
import { Dropdown } from 'semantic-ui-react'
import { DownloadService } from '~/api/services/downloadFiles'
import Layout from '~/components/Layout'
import TableComponent from '~/components/TableComponent'
import DairyQuery from '~/QueryHooks/DairyQuery'
import { handleErrors } from '~/utils/helpers'

const MgaDetails: React.FC = () => {
  const { id } = useParams()
  const { t } = useTranslation()
  const tableColumnHeaders = [
    {
      name: t('Billing month'),
      key: 'billingMonth',
      type: 'date',
      format: 'MMM YYYY'
    },
    {
      name: t('Total amount (in kg)'),
      key: 'amount',
      type: 'no-unit-number',
      decimalScale: 0
    },
    {
      name: t('Fett (in %)'),
      key: 'fat',
      type: 'no-unit-number'
    },
    {
      name: t('Eiweiss (in %)'),
      key: 'protein',
      type: 'no-unit-number'
    },
    {
      name: t('Auszahlungspreis (in Rp./kg)'),
      key: 'price',
      type: 'no-unit-number'
    },
    {
      name: t('Auszahlungsb. (in CHF)'),
      key: 'total',
      type: 'no-unit-number'
    },
    {
      name: t('Actions')
    }
  ]

  const actions = [
    {
      popupMessage: t('Download milk bill'),
      type: 'icon',
      name: 'cloud download',
      size: 'large',
      actionType: 'download'
    }
  ]

  const [loadingAction, setLoadingAction] = useState({
    type: '',
    id: null,
    value: false,
    idKey: ''
  })

  const [dataFiltered, setDataFiltered] = useState({
    rows: 20,
    page: 0,
    farmerId: ''
  })

  const {
    data: invoices,
    isLoading: isLoadingInvoices,
    isFetching: isFetchingData,
    refetch: fetchData
  } = DairyQuery.getManagerMilkPayments(id, {
    ...dataFiltered,
    page: dataFiltered?.page === 0 ? dataFiltered.page : dataFiltered?.page - 1
  })

  const {
    data: mgaData,
    isLoading: isLoadingData
  } = DairyQuery.getManagerMilkPaymentsData(id)

  const farmersOptions = (mgaData?.farmers ?? []).map((farmer) => ({
    value: farmer.id,
    text: farmer.companyName
  }))

  useEffect(() => {
    if (mgaData?.farmers?.length && !dataFiltered?.farmerId) {
      setDataFiltered({
        rows: 20,
        page: 0,
        farmerId: mgaData?.farmers[0]?.id
      })
    }
  }, [mgaData, dataFiltered])

  useEffect(() => {
    fetchData()
  }, [dataFiltered])

  async function handleDownloadPdf(row, type) {
    setLoadingAction({
      type: type,
      id: row.id,
      value: true,
      idKey: 'id'
    })
    try {
      await DownloadService.downloadFileWithName(`managers/${id}/temp/milk-payments/${row?.id}/preview/pdf`)
    } catch (error) {
      handleErrors(error)
    }
    setLoadingAction({
      type: '',
      id: null,
      value: false,
      idKey: ''
    })
  }

  function handleActionClick(row, type) {
    switch (type) {
      case 'download':
        return handleDownloadPdf(row, type)
      default:
        return
    }
  }

  function renderTable() {
    return <TableComponent
      rows={rows}
      total={filtered}
      actions={actions}
      loadingAction={loadingAction}
      tableColumnHeaders={tableColumnHeaders}
      handleClickAction={(row, type) => handleActionClick(row, type)}
      isFetchingData={isFetchingData}
      dataFiltered={dataFiltered}
      handleChangeDataFiltered={(data) => setDataFiltered(data)}
      animated
    />
  }

  function renderActions() {
    return <div style={{ display: 'flex', gap: 20 }}>
      <Dropdown
        selection
        options={farmersOptions}
        value={dataFiltered.farmerId}
        onChange={(_, { value }) => {
          setDataFiltered({
            ...dataFiltered,
            farmerId: value as string
          })
        }}
        placeholder='Betrieb wählen'
      />
    </div>
  }

  const { filtered, rows } = invoices ? invoices : { filtered: 0, rows: [] }

  return <Layout
    title={''}
    childContainerSize={'auto'}
    actions={renderActions()}
    useSpinner
    isBusy={isLoadingInvoices || isLoadingData}
  >
    {renderTable()}
  </Layout>
}
export default MgaDetails